import { VariaveisAmbiente } from "ambiente";
import { useApiBase } from "api/base";
import { PessoaEnderecoModel } from "api/cardapio/models/pessoa/pessoa-model";
import { useCallback } from "react";

export function usePutEndereco() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const putEndereco = useCallback(
        (endereco: PessoaEnderecoModel, empresaId: string) => {
            return invocarApi({
                url: `api/v4/empresa/${empresaId}/pessoa/${endereco.pessoaId}/endereco/${endereco.id}`,
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(endereco),
                enviarTokenUsuario: false,
                baseURL: VariaveisAmbiente.masterApi,
            });
        },
        [invocarApi]
    );

    return {
        ...outrasPropriedades,
        putEndereco,
    };
}